import type { FaireProductEntity } from "../../entity_types/product";

export const p_295syhn48k: FaireProductEntity = {
  token: "p_295syhn48k",
  type: "product",
  name: "Baguette - Turquoise - Gold Earrings",
  brandToken: "b_f0fbd5c7",
  brandName: "JaxKelly",
  imageUrl:
    "https://cdn.faire.com/fastly/216f64886cce231ae0048083a3d6439196a25ed90975da37397d7fb0796226ad.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/08be34167a7b9d445522c4744304573c6fd48ffaf09551375ae6908b7d6fc9aa.jpeg",
    "https://cdn.faire.com/fastly/ff05338374bc22363275153d206a2a3f8cac14546307aee91e181db34d19a17e.jpeg",
    "https://cdn.faire.com/fastly/2a299697c2c691a47a9c9c04168a4be60c4b029d6b44a18d77e969edc00e7778.jpeg",
  ],
  priceDollars: 17.3,
  description:
    "A pair of classic baguette stud earrings designed to add to any stack. \n\nSurgical-grade stainless steel posts - 18K gold plating over brass\nTarnish-free - Long-lasting protective coating safeguarding your jewelry\nHypoallergenic\nNatural Turquoise stone\n5mm x 2mm\nButterfly back",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:12.648Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
